(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_lktn-bundle-info-tooltip"] && !Shopify.designMode) return;
  try {
    (function() {
  function positionTooltip(badge, tooltip) {
    tooltip.style.left = '50%';
    tooltip.style.transform = 'translateX(-50%)';

    var rect = tooltip.getBoundingClientRect();
    var margin = 8;

    if (rect.left < margin) {
      var shift = margin - rect.left;
      tooltip.style.left = 'calc(50% + ' + shift + 'px)';
    } else if (rect.right > window.innerWidth - margin) {
      var shift = rect.right - (window.innerWidth - margin);
      tooltip.style.left = 'calc(50% - ' + shift + 'px)';
    }
  }

  function initTooltips() {
    document.querySelectorAll('.badge--bundle').forEach(function(badge) {
      if (badge.dataset.tooltipInit) return;
      badge.dataset.tooltipInit = 'true';

      var parts = badge.dataset.lktntooltip.split('|');
      var tooltip = document.createElement('div');
      tooltip.className = 'lktn-tooltip';
      tooltip.innerHTML = '<div class="lktn-tooltip-price">' + parts[0] + '</div><div class="lktn-tooltip-note">' + parts[1] + '</div>';
      badge.appendChild(tooltip);

      badge.addEventListener('click', function(e) {
        e.stopPropagation();
        var isVisible = tooltip.classList.contains('lktn-visible');
        document.querySelectorAll('.lktn-tooltip.lktn-visible').forEach(function(t) {
          t.classList.remove('lktn-visible');
        });
        if (!isVisible) {
          tooltip.classList.add('lktn-visible');
          positionTooltip(badge, tooltip);
        }
      });
    });

    document.addEventListener('click', function() {
      document.querySelectorAll('.lktn-tooltip.lktn-visible').forEach(function(t) {
        t.classList.remove('lktn-visible');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTooltips);
  } else {
    initTooltips();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["_lktn-mix-match"] && !Shopify.designMode) return;
  try {
    function mmSetup() {

    const packages = document.querySelectorAll('.mm-package-item');
    const quantityInput = document.querySelector('.quantity-selector__input');

    packages.forEach((p) => {

      if (p.classList.contains('mm-setup')){
        console.log('mm-setup event is already added');
      } else {
        p.classList.add('mm-setup');
        p.addEventListener('click', function () {
          const qty = p.getAttribute('data-qty');        
          quantityInput.value = qty;
          quantityInput.dispatchEvent(new Event('change'))
          
        });
      }
    });

    quantityInput.addEventListener('change', function(){      
      packages.forEach(p => {
        p.classList.remove('mm-selected');
      });

      var newPackage = document.querySelector('.mm-package-item[data-qty="' + quantityInput.value + '"]');
      if (newPackage != null) {
        newPackage.classList.add('mm-selected');
      }
    });    

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            quantityInput.dispatchEvent(new Event('change'));
        })
    });

  }

  document.addEventListener('variant:change', () => mmSetup());
  document.addEventListener('DOMContentLoaded', () => mmSetup());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["_lktn_cart_free_shipping"] && !Shopify.designMode) return;
  try {
    var FREE_SHIPPING_THRESHOLD = 39500;

  function renderProgress(wrapperElement) {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var totalPrice = cart.total_price;
        //console.log('lktn free shipping', totalPrice);

        var shippingEl = document.getElementById('lktn-shipping-line');
        if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
          shippingEl.innerHTML = '✓ Fri fragt til pakkeshop';
          shippingEl.className = 'lktn-shipping-line done';
        } else {
          var missing = ((FREE_SHIPPING_THRESHOLD - totalPrice) / 100).toFixed(0);
          shippingEl.innerHTML = '🚚 Mangler <strong>' + missing + ' kr</strong> til fri fragt (pakkeshop)';
          shippingEl.className = 'lktn-shipping-line not-done';
        }

        var old = document.getElementsByClassName('lktn-cart-freeshipping-in-drawer');
        while (old.length > 0) old[0].remove();

        var shippingInDrawer = shippingEl.cloneNode(true);
        shippingInDrawer.removeAttribute('id');
        shippingInDrawer.classList.add('lktn-cart-freeshipping-in-drawer');
        wrapperElement.appendChild(shippingInDrawer);
      })
      .catch(function () {});
  }

  window.addEventListener('lktn:cart-wrapper-ready', function(e) {
    renderProgress(e.detail.wrapper);
  });

  // Fallback hvis event allerede er fyret
  if (window._lktnCartWrapper) {
    renderProgress(window._lktnCartWrapper);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["_lktn_cart_upsell"] && !Shopify.designMode) return;
  try {
    const ORG_UNIT_PRICE = 179;
  const TIERS = [
    { pairs: 3, unit_price: 149, prev_unit_price: ORG_UNIT_PRICE },
    { pairs: 6, unit_price: 124, prev_unit_price: 149 },
    { pairs: 9, unit_price: 105, prev_unit_price: 124, gift: 'GRATIS vaskepose' },
  ];

  function renderProgress(wrapperElement) {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items;
        var noShowPair = countNoshowPairs(items);

        if (noShowPair == 0) return;

        //console.log('lktn cart upsell', noShowPair);

        var nextTier = null;
        for (const [index, item] of TIERS.entries()) {
          if (noShowPair < item.pairs) {
            nextTier = item;
            break;
          }
        }

        //console.log('selected next tier', nextTier);

        var upsellEl = document.getElementById('lktn-upsell-line');
        if (nextTier == null) {
          upsellEl.className = 'lktn-upsell-line best-price';
          upsellEl.innerHTML = '✓ Bedste pris + gratis vaskepose 🎁';
        } else {
          console.log("nextTier", nextTier);

          var missingPair = nextTier.pairs - noShowPair;
          var nextTierUnitPrice = nextTier.unit_price;
          var prevTierUnitPrice = nextTier.prev_unit_price;
          var nextTierDiscountUnit = ORG_UNIT_PRICE - nextTierUnitPrice;

          upsellEl.className = 'lktn-upsell-line next-tier';
          //upsellEl.innerHTML = '💰 Køb ' + missingPair + ' par mere og betal kun ' + nextTierUnitPrice + ' kr/par';
          upsellEl.innerHTML = '💰 Køb ' + missingPair + ' par mere og gå fra ' + prevTierUnitPrice + ' → ' + nextTierUnitPrice + ' kr/par';

          if (nextTier.gift != null) upsellEl.innerHTML += '<br>🎁 ' + nextTier.gift;
        }

        var old = document.getElementsByClassName('lktn-cart-upsell-in-drawer');
        while (old.length > 0) old[0].remove();

        var shippingInDrawer = upsellEl.cloneNode(true);
        shippingInDrawer.removeAttribute('id');
        shippingInDrawer.classList.add('lktn-cart-upsell-in-drawer');
        wrapperElement.appendChild(shippingInDrawer);
      })
      .catch(function () {});
  }

  function countNoshowPairs(items) {
    let count = 0;
    items.forEach(function (item) {
      if (item.handle && item.handle.indexOf('noshow') !== -1) {
        count += item.quantity;
      }
    });
    return count;
  }

  window.addEventListener('lktn:cart-wrapper-ready', function (e) {
    renderProgress(e.detail.wrapper);
  });

  // Fallback hvis event allerede er fyret
  if (window._lktnCartWrapper) {
    renderProgress(window._lktnCartWrapper);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["_lktn_shipping_timer"] && !Shopify.designMode) return;
  try {
    function render() {
    fetch('https://opshub.lktn.dk/api/public/shipping/cutoff')
      .then((r) => r.json())
      .then((data) => {
        var shippingCutoff = data;

        if (shippingCutoff.today) {
          elementRemoveClass('.timer-today', 'timer-hidden');

          var cutoffTime = new Date(data.cutoffAt).getTime();
          var timerInterval = null;

          function updateTimer() {
            var remaining = Math.floor((cutoffTime - Date.now()) / 1000);

            if (remaining <= 0) {
              elementAddClass('.timer-today', 'timer-hidden');
              clearInterval(timerInterval);
              render();
              return;
            }

            var h = Math.floor(remaining / 3600);
            var m = Math.floor((remaining % 3600) / 60);
            var s = remaining % 60;

            var formatted =
              (h > 0 ? String(h).padStart(2, '0') + ':' : '') +
              String(m).padStart(2, '0') +
              ':' +
              String(s).padStart(2, '0');

            formatted = 'kl. ' + data.clock;
            elementSetContent('.timer-today-badge', formatted);

            if (remaining < 3600) {
              elementAddClass('.timer-today-badge', 'urgent');
            }
          }

          timerInterval = setInterval(updateTimer, 1000);
          updateTimer();          
        } else {
          elementRemoveClass('.timer-text', 'timer-hidden');

          if (shippingCutoff.tomorrow) {
            elementSetContent('.timer-text-badge', 'i morgen kl. ' + shippingCutoff.clock);
          } else {
            elementSetContent('.timer-text-badge', shippingCutoff.text);
          }
        }
      })
      .catch(function (err) {
        console.error('Shipping cutoff fejlede:', err);
        elementAddClass('.lktn-shipping-timer', 'timer-hidden');
      });
  }

  function elementSetContent(selector, text) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.innerHTML = text;
    });
  }

  function elementAddClass(selector, className) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.classList.add(className);
    });
  }

  function elementRemoveClass(selector, className) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.classList.remove(className);
    });
  }

  document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('variant:change', injectInventory);

  injectInventory();

  function injectInventory() {
    var soldOutBadge = document.querySelector('sold-out-badge');
    if (soldOutBadge != null) return;

    var variantInventoryElement = document.querySelector('variant-inventory');

    if (variantInventoryElement == null) return;

    var spanElement = variantInventoryElement.querySelector('span');
    if (spanElement == null) return;

    var shippingTimerElement = variantInventoryElement.querySelector('.lktn-shipping-timer');
    if (shippingTimerElement != null) return;

    var rootElement = document.getElementById('lktn-shipping-timer-wrapper').querySelector('.lktn-shipping-timer');
    if (rootElement == null) return;
    var newElement = rootElement.cloneNode(true);

    spanElement.after(newElement);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["_lktn_wrapper"] && !Shopify.designMode) return;
  try {
    function renderWrapper() {
    if (document.querySelector('.lktn-cart-wrapper')) {
      return;
    }

    var drawerItems = document.getElementsByClassName('cart-drawer__line-items')[0];
    if (!drawerItems) return;

    var wrapperElement = document.createElement('div');
    wrapperElement.classList.add('lktn-cart-wrapper');
    drawerItems.before(wrapperElement);

    window._lktnCartWrapper = wrapperElement;
    window.dispatchEvent(
      new CustomEvent('lktn:cart-wrapper-ready', {
        detail: { wrapper: wrapperElement },
      })
    );
  }

  document.addEventListener('DOMContentLoaded', renderWrapper);
  window.addEventListener('cart:change', renderWrapper);
  window.addEventListener('cart:refresh', renderWrapper);

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function () {
      if (!document.querySelector('.lktn-cart-wrapper')) {
        renderWrapper();
      }
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
  } catch(e) { console.error(e); }
})();

})();
